module.exports = __webpack_public_path__ + "static/media/Technological.885504b3.png";